import { create } from "zustand";
import { ShopSlice, createShopSlice } from "./shop.slice";
import { AuthSlice, createAuthSlice } from "./auth.slice";
import { UserSlice, createUserSlice } from "./user.slice";
import { ListenersSlice, createListenersSlice } from "./listeners.slice";
import { AnalyticsSlice, createAnalyticsSlice } from "@/stores/analytics.slice";
import {
  CustomerUpdatesSlice,
  createCustomerUpdatesSlice,
} from "@/stores/customerUpdates.slice";
import { TaskSlice, createTaskSlice } from "@/stores/task.slice";

const useStore = create<
  ShopSlice &
    AuthSlice &
    UserSlice &
    ListenersSlice &
    AnalyticsSlice &
    CustomerUpdatesSlice &
    TaskSlice
>()((...a) => ({
  ...createShopSlice(...a),
  ...createAuthSlice(...a),
  ...createUserSlice(...a),
  ...createListenersSlice(...a),
  ...createAnalyticsSlice(...a),
  ...createCustomerUpdatesSlice(...a),
  ...createTaskSlice(...a),
}));

const store = useStore;
export { useStore, store };
